import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService, XenaClient } from 'src/app/services';
import { BaseService } from 'src/app/xena-api/controllers/base';
import { IOrderTaskLine } from 'src/app/xena-api/dtos';
import { IListOptionsFilter } from 'src/app/xena-api/filters';

@Injectable({
  providedIn: 'root'
})
export class OrderTaskLineService extends BaseService<IOrderTaskLine, IListOptionsFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'OrderTaskLine');
  }

  bulk(orderTaskLines: IOrderTaskLine[]): Observable<IOrderTaskLine[]> {
    const path = `/Fiscal/${this.context.fiscalId}/OrderTaskLine/Bulk`;
    return this.xenaClient.post<IOrderTaskLine[], IOrderTaskLine[]>(path, orderTaskLines);
  }
}
